__turbopack_context__.v({
  "subtitle": "ekkhEW_subtitle",
  "wrapper": "ekkhEW_wrapper",
});
